import { useTranslation } from "react-i18next";
import { Button, Modal } from "antd";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  price: string;
  expireAt: string | null;
}

export const SubscriptionRestoreModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  price,
  expireAt,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={t("subscription.dialogs.preRestoringTitle")}
      onCancel={() => {
        if (!loading) onClose();
      }}
      closable={!loading}
      keyboard={!loading}
      mask={{ closable: !loading }}
      footer={
        <div style={{ display: "flex", gap: 8 }}>
          <Button
            size="large"
            type="primary"
            loading={loading}
            onClick={onConfirm}
          >
            {t("app.continue")}
          </Button>
          <Button size="large" disabled={loading} onClick={onClose}>
            {t("team.cancel")}
          </Button>
        </div>
      }
    >
      <p>
        {t("subscription.dialogs.weWillRenewSubscription", {
          price,
          date: expireAt ?? "",
        })}
      </p>
    </Modal>
  );
};
